module.exports = __webpack_public_path__ + "img/oga.fdd879e6.png";